var shopifyCountrySettings = {
    country: null,
    options: {
        'jp': {
            'domain': '.jp.mobvoi.com',
            'currency': 'JPY',
            'language': 'ja'
        },
        'aus': {
            'domain': '.au.mobvoi.com',
            'currency': 'AUD'
        },
        'fr': {
            'domain': '.eu.mobvoi.com',
            'currency': 'GBP',
            'language': 'fr'
        },
        'de': {
            'domain': '.eu.mobvoi.com',
            'currency': 'GBP',
            'language': 'de'
        }
    },
    init: function (country) {
        if (!country) return;
        this.country = country;
        this.currency();
        this.lang();
    },
    /* Shopify currency */
    // set default currency
    currency: function () {
        var self = this;
        if (!self.__hasCookie('currency')) {
            var _date = new Date();
            _date.setDate(_date.getDate() + 365);
            var domain = self.options[self.country].domain;
            var currency = self.options[self.country].currency;
            var expires = _date.toGMTString();
            self.__setCookie('currency', currency, domain, expires, '/');
        }
    },
    /* Shopify App Plugin: Weglot Translate */
    // set default language
    lang: function () {
        var self = this;
        var sessionLang = sessionStorage.getItem('wglang');
        if (self.options[self.country]) {
            var lang = self.options[self.country].language;
            if (!sessionLang && self.options[self.country].language) {
                sessionStorage.setItem('wglang', lang);
            }
        }
    },
    __hasCookie: function (name) {
        var result = false;
        if (document.cookie.length > 0) {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                if (cookies[i].trim().indexOf(name) === 0) {
                    result = true;
                    break;
                }
            }
            return result;
        }
    },
    __setCookie: function (name, value, domain, expires, path) {
        document.cookie = name + '=' + value + '; expires=' +
            expires + 'path=' + path + '; domain=' + domain;
    }
};
